import { getEnv } from "../../helpers/env";

export const SiteConstants = {
  bitmovinPlayerKey: "18d42a4c-8e50-4078-9fd4-361f8f7c7e61",
  bitmovinAnalyticsKey: "aeb309b2-4162-4050-8f7f-eb0ab6004fe2",
  SignIn: "signin",
  SignupInit: "signup",
  SignupForm: "signupform",
  SignupPreferences: "signupref",
  SignupEmail: "signupemail",
  ResetPassword: "resetpassword",
  ResetPasswordEmail: "resetemail",
  SendPassword: "sendpassword",
  ConfirmResetPassword: "confirmresetpassword",
  Personal: "personal",
  Secruity: "security",
  DataPrivacy: "privacy",
  MIN_SEARCH_TEXT_LENGTH: 3,
  Campaign: 'campaign',
  doneTypingInterval: 500,
  ENTER_KEY_EVENT_CODE: 13
};

export const MetaContent = {
  home: {
    title:
      "ausbiz TV - Live Australian news of Business, Markets, Economy and Startups",
    description:
      "Australia's leading provider of live and on-demand video of the latest news in Australian business, markets, economy and startups.",
    subject: "Business",
    keywords:
      "watch live business, finance news, chi-x, watch live tv, business news, australian markets, australian finance, ausbiz, asx live, live stocks australia",
    thumbnailImage: getEnv("AUSBIZ_BANNER"),
    twitterCard: "summary_large_image"
  },
  signin: {
    title: "Sign in | ausbiz",
    description:
      "Watch live and on-demand video of the latest in Australian business, markets, economy and startups."
  },
  signup: {
    title: "Sign up for free | ausbiz",
    description:
      "Sign up for free access to live and on-demand video coverage of the latest in Australian business, markets, economy and startups."
  }
};

export const HomeObject = {
  home: {
    title: "ausbiz TV - Live",
    description:
      "Australia's leading provider of live and on-demand video of the latest news in Australian business,markets,economy and startups",
    subject: "Business",
    keywords:
      "watch live business, finance news, chi-x, watch live tv, business news, australian markets, australian finance, ausbiz, asx live, live stocks australia",
    thumbnailImage: getEnv("AUSBIZ_BANNER")
  }
};
